import { Container } from 'components/atoms';
import { AddressForm, FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiBank } from 'react-icons/pi';
import { CUSTOMER_TYPE, ILabelForm } from 'services/labels/types';
import { useStateStorage } from 'store/state';

const LabelFinances = () => {
  const { values } = useFormikContext<ILabelForm>();
  const { t } = useTranslation();

  const { countries } = useStateStorage();

  const countrySelectOptions =
    countries?.map(country => ({
      label: t(`countries.${country.codeAlfa2}`),
      value: country.codeAlfa2,
    })) ?? [];

  return (
    <div className='flex gap-6 justify-start w-full'>
      <AddressForm propertyPrefix='address.' />
      <AddressForm
        propertyPrefix='taxOffice.'
        title={t('label.tax-office.address')}
        topContent={
          <Container.Content>
            <FormInput.Text
              name={`taxOffice.name`}
              label={t('input.label.name')}
              wrapperClassName='max-w-80'
            />
          </Container.Content>
        }
      />
      <Container className='self-start w-full max-w-[350px]'>
        <Container.Header
          title={
            <>
              <PiBank /> {t('label.accounting.header')}
            </>
          }
        />
        <Container.Content>
          <div className='flex flex-col w-full gap-3'>
            {values.customerType === CUSTOMER_TYPE.Physical ? (
              <>
                <FormInput.Select
                  name={'personalIdCountryAlfa2'}
                  label={t('input.label.country')}
                  options={countrySelectOptions}
                />
                <FormInput.Text
                  name='personalId'
                  label={t('input.label.personalId')}
                />
              </>
            ) : (
              <>
                <FormInput.Select
                  name={'companyCountryAlfa2'}
                  label={t('input.label.country')}
                  options={countrySelectOptions}
                />
                <FormInput.Text
                  name='companyId'
                  label={t('input.label.companyId')}
                />
              </>
            )}
            <FormInput.Text
              name='bankAccountNumber'
              label={t('input.label.bankAccountNumber')}
            />
            {(values.customerType === CUSTOMER_TYPE.Physical
              ? values.personalIdCountryAlfa2
              : values.companyCountryAlfa2) === 'US' && (
              <FormInput.Text
                name='routingNumber'
                label={t('input.label.routingNumber')}
              />
            )}
            <FormInput.Text name='bankName' label={t('input.label.bankName')} />
            <FormInput.Text name='swift' label={t('input.label.swift')} />
          </div>
        </Container.Content>
      </Container>
    </div>
  );
};

export default LabelFinances;
